import { useEffect, useState } from 'react'
import { getAsync } from '../../../shared/api.service'

// Records of what a person did belong to the learner's organization. The org
// reports list only this organization's own learners (on any course, public
// library courses from other organizations included), and the course reports
// list only its own learners on that course. Learners from other
// organizations who played this organization's courses are never listed by
// name: the server returns them as a count only, from
// report-general-org/external-summary (optionally for one course, ?nodeID=).
//
// Fetched with the plain service call, not an api-new hook: those hooks return
// a new object each render and would re-run the effect.
export const useExternalLearnerSummary = nodeID => {
  const [summary, setSummary] = useState()

  useEffect(() => {
    let live = true
    const query = nodeID ? `?nodeID=${nodeID}` : ''
    getAsync(process.env.REACT_APP_API_ANALYTICS, `api/v1/report-general-org/external-summary${query}`)
      .then(result => live && setSummary(result.data))
      .catch(() => {
        // Optional context. An older server without the endpoint, or a failed
        // request, just leaves the note out.
      })
    return () => { live = false }
  }, [nodeID])

  return summary
}

export const externalLearnersText = (summary, { course = false } = {}) => {
  const sessions = summary?.sessions || 0
  if (sessions <= 0) return undefined
  const where = course ? 'this course' : 'your courses'
  return `Learners from other organizations: ${sessions} ${sessions === 1 ? 'session' : 'sessions'} on ${where}. They are shown as a count only.`
}

// externalUser comes from the server as the text 'true' / 'false' (it means
// the session was on another organization's course). Show words.
export const otherOrgCourseLabel = row => (row?.externalUser === true || row?.externalUser === 'true' ? 'Yes' : 'No')
